import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

import LoadingSpinner from '../Shared/LoadingSpinner';
import { isAdminAppUser } from '../../utils/responsePartnerUtils';

const AdminRoute = ({ children }) => {
  const { isLoaded, user } = useUser();

  if (!isLoaded) {
    return <LoadingSpinner />;
  }

  if (!isAdminAppUser(user)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
